export enum AppRouterConstants {
  LOGIN_CALLBACK_ROUTE = '/login/callback',
  LOGIN_ROUTE = '/login',
  SPLASH_ROUTE = '/splash',
  LANDING_PAGE_ROUTE = '/landing',
  SERVICE_SELECTION_ROUTE = '/serviceSelection',
  HOME_ROUTE = '/home',
  DEMO_ROUTE = '/demo',
  CREW_ROUTE = '/crew',
  TABS_ROUTE = '/tabs',
  DL_SCANNER_ROUTE = '/dlScanner',
  DOCUMENT_SCANNER_ROUTE = '/documentScanner',
  SIGNATURE_ROUTE = '/signatures',
  EKG_IMPORT_ROUTE = '/ekgImport',
  INDEX_ROUTE = '/',
  TERMS_CONDITIONS_TAB = '/termsAndConditions',
  CAMERA_ATTACHMENTS_ROUTE = '/cameraAttachments',
  HELP_ROUTE = '/helpGuide',
  COMMENTS_PAGE_ROUTE = '/comments',
  SPECIAL_REPORTS_ROUTE = '/specialReports',
  FILLABLE_PDFS_ROUTE = '/fillablePDFs',
  PULSARA_ROUTE = '/pulsara',
  QA_ADDENDUM_FLAG_RESOLUTION_ROUTE = '/qaAddendum/flagResolution',
  QA_ADDENDUM_FLAG_REASSIGN_ROUTE = '/qaAddendum/flagResolution/reassign',
  QA_ADDENDUM_FLAG_HISTORY_ROUTE = '/qaAddendum/flagResolution/history',
  QA_ADDENDUM_FLAG_CHART_SUMMARY_ROUTE = '/qaAddendum/flagResolution/chartSummary/:pageSlug',
}

export const qaFlagChartSummaryPath = (pageSlug: string): string =>
  `/qaAddendum/flagResolution/chartSummary/${pageSlug}`
